import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-arrow-after",
  "use": "ico-arrow-after-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol viewBox=\"0 0 12 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-arrow-after\">\r\n    <path d=\"M0.0117188 0V1.11328C0.0117188 6.01562 3.99609 10 8.89844 10H10.0352L7.76562 12.2695L8.47266 12.9805L11.9531 9.5L8.47266 6.02344L7.76562 6.72656L10.0352 9H8.89844C4.53906 9 1.01172 5.47266 1.01172 1.11328V0H0.0117188ZM10.5117 9.47266L10.5352 9.5L10.5117 9.52734V9.47266Z\" fill=\"#0078D4\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol